import { Account } from 'types/Account'
import { fetchAccount, fetchPbxId } from 'utils'

const fetchSelectedAccountDetails = async (accountKey: string): Promise<Account | null> => {
  const pbxId = await fetchPbxId(accountKey)
  const account = await fetchAccount(accountKey)

  if (account) {
    return {
      key: accountKey,
      name: account.name || '',
      orgId: pbxId || '',
      partnerAccountKey: account.partnerAccountKey,
      unifiedAdmin: account.unifiedAdmin,
    }
  }
  return null
}

export default fetchSelectedAccountDetails
